module.exports = __webpack_public_path__ + "static/media/27OCHA12.6ed94143.jpg";